"use strict";
var $Object = require("es-object-atoms");
module.exports = $Object.getPrototypeOf || null;
